import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import backgroundImage from '../assets/images/home/bg.png'
import startBtnImage from '../assets/images/home/start.png';

import Cookies from 'universal-cookie';
import fetchTimeout from 'fetch-timeout';
import loginBackgroud from '../assets/images/login/bg.png';
import loginBtn from '../assets/images/login/login.png'
import cancelBtn from '../assets/images/login/pass.png'

import constant from '../assets/const.json';

const cookies = new Cookies();

class Home extends Component {

    btnSound = './sounds/btn1.mp3';

    constructor(props) {
        super(props);
        this.state = {
            uid: '',
            showDialog: false,
            loginOpacity: 0.0
        };
    }
    
    componentDidMount() {
        let uid = cookies.get('uid');
        if (uid === null || uid === undefined) {
            uid = ''
        }
        this.setState({
            uid: uid
        });
    }

    getRequestBody(uid) {
        return {
            uid: uid,
            action: 'start'
        };
    }

    postDataToServer(uid) {
        let apiPath = constant.WEB_API_PATH;
		fetchTimeout(apiPath, {
            headers: {
                'Content-Type': 'application/json'
            },
			method: 'POST',
			body: JSON.stringify(this.getRequestBody(uid))
        }, 5 * 1000, '[WebAPI] Timeout')
        .then(response => response.json())
		.then(data => {
			if (data.success) {
                // call api ok
                console.log('[WebAPI] success');
            } else {
                // call api failed
                console.log('[WebAPI] failed');
            }
		}).catch(e => {
			console.log('[WebAPI] ' + e);
		});
    }
    
    goToDesc1Page() {
        this.playBtnSound();
        this.postDataToServer(this.state.uid);
        if (this.state.uid === '') {
            this.setState({
                showDialog: true,
                loginOpacity: 1.0
            });
        } else {
            this.forceGoToDesc1Page()
        }
    };

    forceGoToDesc1Page() {
        this.playBtnSound();
        this.props.history.push({
            pathname: './desc1',
            state: {}
        });
    }

    goToLoginPage() {
        this.playBtnSound();
        window.top.location = constant.LOGIN_URL
    }

    playBtnSound() {
        let btnAudio = new Audio(this.btnSound);
        btnAudio.play();
    }

    render() {
        return (
            <div className='page-root-div'>
                <img alt='' src={backgroundImage} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                <img alt='' src={loginBackgroud} style={{ position: 'absolute', width: '100%', left: '0%', top: '0%', opacity: `${ this.state.loginOpacity }` }}></img>
                {
                    !this.state.showDialog && (<img className='press-btn' alt='' src={startBtnImage} style={{ height: '9.5%', top: '55%', left: '21%', position: 'absolute' }} onClick={this.goToDesc1Page.bind(this)}/>)
                }
                {
                    this.state.showDialog && (<div style={{ position: 'absolute', height: '70.5%', width: '67%', left: '5.8%', top: '4%', background: 'transparent', zIndex: '1' }}>
                        <img alt='' className='press-btn' src={loginBtn} style={{ position: 'absolute', width: '29%', left: '14.5%', bottom: '14%' }} onClick={this.goToLoginPage.bind(this)}></img>
                        <img alt='' className='press-btn' src={cancelBtn} style={{ position: 'absolute', width: '29%', right: '14.5%', bottom: '14%' }} onClick={this.forceGoToDesc1Page.bind(this)}></img>
                    </div>)
                }
            </div>
        )
    }
}

export default withRouter(Home);
